/**
 * ActivationDevicesCtrl controller
 * Show devices on activation page
 */

import { add, remove, isEnabled, ascSortOrder } from 'app/helpers/entity'

/**
 * ActivationDevicesCtrl controller
 *
 * @class ActivationDevicesCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationDevicesCtrl
 */
/* @ngInject */
export default function ActivationDevicesCtrl ($scope, Device, DeviceSlot, subscr, extra, scope) {
  var vm = this

  vm.APP_DEVICE_LINK_CODE_ENABLED = !!window.ENV.APP_DEVICE_LINK_CODE_ENABLED

  /**
   * Subscriber
   *
   * @memberof mwApp/subscribers.controller:ActivationDevicesCtrl
   * @type {models.Subscriber}
   */
  vm.subscr = subscr

  /**
   * Shared scope
   *
   * @memberof mwApp/subscribers.controller:ActivationDevicesCtrl
   * @type {Object}
   */
  vm.scope = scope

  /*
   * Devices in scope
   */
  scope.devices = {
    enabled: subscr.devices.filter(isEnabled),
    slots: subscr.deviceSlots,
    isDeviceOrSlot (n) { return +n < this.enabled.length },
    count () { return this.enabled.length + this.slots.length }
  }
  vm.stationaryTypes = ['STB', 'TVOS', 'LG', 'PC', 'SamsungTV', 'Others']

  /**
   * Move enabled devices up and down
   */
  vm.up = function (device) {
    device._up(scope.devices.enabled)
      .then(fixStatus) // TODO remove this hack (and orange status also)
  }
  vm.down = function (device) {
    device._down(scope.devices.enabled)
      .then(fixStatus) // TODO remove this hack (and orange status also)
  }

  // TODO remove this hack (and orange status also)
  function fixStatus () {
    scope.devices.enabled.sort(ascSortOrder)
    scope.devices.enabled.forEach((d, i) => { d.status = i < subscr._paidDeviceCount() })
  }

  /**
   * Set device
   *
   * @memberof mwApp/subscribers.controller:ActivationDevicesCtrl
   * @param {models.Device} device
   */
  vm.setPrimary = function (device) {
    var setPrimary = device.staticDevice ? !device.primaryDevice : true
    device._primary(setPrimary)
      .then(
        () => {
          if (setPrimary) {
            scope.devices.enabled.forEach(
              d => {
                d.staticDevice = true
                d.primaryDevice = false
                d.sortOrder += 2
              }
            )
            device.primaryDevice = true
            device.sortOrder = 1
          } else {
            scope.devices.enabled.forEach(
              d => {
                d.staticDevice = false
              }
            )
          }
        }
      )
  }

  /* === Work with Device Slots === */

  /**
   * Broadcast 'event:changePasswordRequired' for ActivationPaymentsCtrl controller
   */
  function broadcastDeviceSlotsAmountChangedEvent () {
    /**
     * Event occurs when backend return require for user to change password <br>
     * Fires in {@link mwApp/auth.service:authSvc} service
     *
     * @event event:changePasswordRequired
     * @memberof mwApp
     */
    $scope.$parent.$broadcast('event:deviceSlotsAmountChanged')
  }

  /**
   * Add slot to subscriber
   *
   * @memberof mwApp/subscribers.controller:ActivationDevicesCtrl
   */
  vm.addSlot = function () {
    var slot = new DeviceSlot({ subscriber: subscr })
    slot._save()
      .then(add(vm.scope.devices.slots)(slot))
      .then(broadcastDeviceSlotsAmountChangedEvent)
  }

  /**
   * Delete slot from subscriber
   *
   * @memberof mwApp/subscribers.controller:ActivationDevicesCtrl
   */
  vm.deleteSlot = function (slot) {
    slot._delete()
      .then(remove(vm.scope.devices.slots)(slot))
      .then(broadcastDeviceSlotsAmountChangedEvent)
  }

  /**
   * Create link for slot
   *
   * @memberof mwApp/subscribers.controller:ActivationDevicesCtrl
   */
  vm.linkSlot = function (slot) {
    slot._link()
  }

  /**
   * Unlink slot
   *
   * @memberof mwApp/subscribers.controller:ActivationDevicesCtrl
   */
  vm.unlinkSlot = function (slot) {
    slot._unlink()
  }
}
